import { Expose } from "class-transformer";

export class SetInvoicesDeliveredToBulkDto {
  @Expose()
  invoiceIds: string[];

  @Expose()
  deliveredTo: string;
}
